bcn.events = (function () {

'use strict';

  function previewUpload () {
    $('body').on('change', '#event_image', function () {
      bcn.imageUploadPreview.previewImage(this);
    });
  }

  function prefillSlug() {
    $('#event_name').change(function(){
      $('#event_slug').val(
          $('#event_name').val()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g,'-')
          .replace(/(^-|-$)/g,'')
        );
    });
  }

  function previewUpload () {
    $('#event_image').on('change', function(){
      console.log('previewUpload');
      bcn.imageUploadPreview.previewImage(this);
      $('.photo-upload').addClass('uploaded');
      if($('.photo-upload__uploaded-info').length === 0) {
        $(this).parent()
          .append('<div class="photo-upload__uploaded-info"><p class="photo-upload__message">Photo uploaded</p><button type="button" class="button-link photo-upload__remove" data-upload-remove>Remove this photo</button></div>');
      }
      $('.photo-upload__preview-image').show();
    });
  }

  function checkHiddenField () {
    var $hiddenField = $('#refile-input').find('input[type="hidden"]:first');

    if ($hiddenField.length) {
      var hiddenFilename = JSON.parse($hiddenField.val()).filename;
      if (typeof hiddenFilename !== 'undefined') {
        $('#event-photo-cached').show();
        $('#event-photo-cached-details').text(hiddenFilename);
        $('[data-upload-image-type]').addClass('uploaded');
      }
    }
  }

  function hideCachedInfo () {
    if ($('#event-photo-cached').length) {
      $('#event-photo-cached').hide();
      $('#event-photo-cached-details').text('');
    }
  }

  return {
    init: function () {
      previewUpload();
      prefillSlug();
      checkHiddenField();
      previewUpload();
    },
    hideCachedImageDetails: function () {
      hideCachedInfo();
    }
  };

})();
